<template>
  <div>
    <h6>Ej tillåtet</h6>
    <p>
      Sidan du försöker nå finns inte eller så har du inte tillåtelse att se
      den.
    </p>
  </div>
</template>
